import { render, staticRenderFns } from "./CryptomatsOrders.vue?vue&type=template&id=770f6f38&scoped=true&"
import script from "./CryptomatsOrders.vue?vue&type=script&lang=js&"
export * from "./CryptomatsOrders.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsOrders.vue?vue&type=style&index=0&id=770f6f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f6f38",
  null
  
)

export default component.exports